import { Popup } from '@/types/api/mypage/loginMessage';
import url from '@/utils/config';
import ExternalLink from '../atoms/ExternalLink';
import Button from '../atoms/Button';
import Heading from '../atoms/Heading';

type Props = Popup & {
  onClose: () => void;
};

/**
 * ログイン直後に表示する運営メッセージを、詳細リンク付きで強調表示するポップアップ。
 * 重要なお知らせを通常画面に埋もれさせず、確認後に閉じられる形で見せるための部品。
 */
const LoginMessagePopup: React.FC<Props> = ({ title, text, link, onClose }) => {
  return (
    <>
      <div className='m-popup js-popup is-popup-fade is-popup-show' id='popup-use-01'>
        <div className='m-popup__inner'>
          <div className='m-popup__content'>
            <div className='m-popup__title'>
              <img
                src={url('/images/icon_exclamation_popup.svg')}
                alt='警告アイコン'
                className='m-popup__icon'
              />
              <Heading as='h2' className='m-popup__heading'>
                {title}
              </Heading>
            </div>
            <div className='m-popup__text'>
              <p>{text}</p>
              <br />
              <br />
              {/* 詳細導線は本文と切り離して強調し、重要告知の深掘り先を迷わせない。 */}
              <ExternalLink href={link.url}>{link.text}</ExternalLink>
            </div>
            <div className='m-popup__footer'>
              <div className='m-button align-center'>
                <Button
                  variant='secondary'
                  onClick={onClose}
                  className='m-popup__button'
                  icon={false}
                >
                  閉じる
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        role='button'
        tabIndex={0}
        className='fn-overlay is-overlay-show'
        onClick={onClose}
        onKeyDown={onClose}
        aria-label='閉じる'
        data-testid='show'
      />
    </>
  );
};

export default LoginMessagePopup;
